import { Tooltip, styled } from "@mui/material";
import { tokens } from "../../theme/theme";

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    arrow
    placement="right-start"
    classes={{ popper: className }}
  />
))(({ theme }) => {
  const colors = tokens(theme.palette.mode);

  return {
    [`& .MuiTooltip-tooltip`]: {
      backgroundColor: colors.blueAccent[500],
      color: "#fff",
      fontSize: "14px",
      borderRadius: "10px",
      padding: "10px",
      maxWidth: 260,
    },
    [`& .MuiTooltip-arrow`]: {
      color: colors.blueAccent[500],
    },
  };
});

export default CustomTooltip;
